import { Flash } from 'AWS-UI-Components-React';
import React from 'react';
import { ApiInvocationStatus } from '../../constants/constants';
import { getElements } from './graph_element_generator';
import { SimulationDetailsView } from './simulation_details_view';

const GRAPH_RELOAD_TIMEOUT = 250;

export class SimulationGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      id: this.props.id,
      status: ApiInvocationStatus.NOT_INVOKED,
    };
  }

  nodeSelected = (event) => {
    var node = event.target;
    console.log('tapped ' + node.id());
    // TODO Display detailed info about the step
    // let id = `
    // ${node.data().events}
    // `;
    // this.cy.add({
    //          group: 'nodes',
    //          data: { id: id },
    //          position: { x: node.position().x, y: node.position().y + node.height() * 2 }
    //        });
  };

  reloadGraph = (simulationDetails, selectedSimulationRuntime) => {
    if (document.getElementById('cy')) {
      this.cy = cytoscape({
        container: document.getElementById('cy'),
        elements: getElements(simulationDetails, selectedSimulationRuntime),
        style: this.getStyles(),
        layout: this.getLayout(),
      });
      this.cy.$('node').one('tap', this.nodeSelected);
    }
  };

  getStyles() {
    return [
      {
        selector: 'node',
        style: {
          width: 'label',
          shape: 'round-rectangle',
          'background-color': 'data(color)',
          label: 'data(id)',
          'text-valign': 'center',
          'border-style': 'solid',
          'border-width': '1px',
          'padding-right': '15px',
          'padding-left': '15px',
          'padding-top': '5px',
          'padding-bottom': '5px',
        },
      },
      {
        selector: 'edge',
        style: {
          'curve-style': 'bezier',
          'target-arrow-shape': 'triangle',
          'target-arrow-fill': 'filled',
          width: '2px',
        },
      },
    ];
  }

  getLayout() {
    return {
      name: 'breadthfirst',
      spacingFactor: 0.9,
      directed: true,
      fit: true,
      padding: 5,
    };
  }

  render() {
    const { status, simulationDetails, selectedSimulationRuntime} = this.props;
    const loadComplete = ApiInvocationStatus.isComplete(status);
    if (loadComplete) {
      setTimeout(() => this.reloadGraph(simulationDetails, selectedSimulationRuntime), GRAPH_RELOAD_TIMEOUT);
    }

    return (
      <div className={'graph-border'}>
        <Flash visible={!loadComplete} loading={true} content={'Fetching the simulation events'} />
        <div id="cy" style={{ display: loadComplete ? 'block' : 'none' }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/simulation_graph.jsx